import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box, Stack, Button } from '@mui/material';
import FileIcon from '../../FileIcon';
import { Email } from 'mdi-material-ui';
import { WhatsApp } from '../../SharePopper/ShareIcons';
import SharedTypography from '../../Typography';
const Share = ({ files }) => {
    const getEmailShareLink = (files) => {
        const urls = files
            .map((file, index) => `${index + 1}. ${encodeURIComponent(file.url)} \n`)
            .join('\n');
        return `mailto:?Subject=Link to download file&body=Please download the files using the links below:\n\n ${urls}`;
    };
    const getWhatsappShareLink = (files) => {
        const urls = files
            .map((file, index) => `${index + 1}. ${encodeURIComponent(file.url)} \n`)
            .join('\n');
        return `whatsapp://send?text=This is WhatsApp sharing example using link \n\n ${urls}`;
    };
    return (_jsxs(Box, Object.assign({ display: "inline-block", p: "5px" }, { children: [_jsx(Typography, Object.assign({ variant: "h4", sx: { fontWeight: '500px', color: '#172B4D' } }, { children: "Now you can share your file to your Friends" })), _jsx(Stack, Object.assign({ maxHeight: "150px", spacing: 2, mt: 2, mb: 2, sx: {
                    overflowY: 'auto',
                    width: '100%',
                    '&::-webkit-scrollbar': {
                        width: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: '2px',
                    },
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'auto transparent',
                } }, { children: files.map((file, idx) => (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", paddingRight: "12px", spacing: 2 }, { children: [_jsx(FileIcon, { filename: file.name }), _jsx(SharedTypography, Object.assign({ variant: "body2", color: "text.dark", sx: {
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                                width: '180px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                            }, clamp: 2 }, { children: file.name }))] }), idx))) })), _jsxs(Stack, Object.assign({ direction: "row", spacing: 2, justifyContent: "space-around" }, { children: [_jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(Email, {}), target: "_blank", href: getEmailShareLink(files), sx: { padding: '2px 10px' } }, { children: "Email" })), _jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(WhatsApp, {}), target: "_blank", href: getWhatsappShareLink(files), sx: { padding: '2px 10px' } }, { children: "Whatsapp" }))] }))] })));
};
export default Share;
